import React from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { updateDataRole } from 'js/actions/roleActions';
import { translatePermission } from 'helpers/translate';

import {
  Typography,
  List,
  ListItem,
  ListItemText,
  Button,
  Box,
} from '@mui/material';

import { useIntl } from 'react-intl';

function NameRoleForm() {
  const intl = useIntl();
  const formData = useSelector((state) => state.forms);
  const dispatch = useDispatch();
  const { data } = formData;
  const permission = data[1];

  const role = {
    role_name: data[0].role_name,
    is_public: parseInt(data[0].is_public),
    permissions: [],
    is_global: false,
  };

  Object.keys(permission).forEach((key) => {
    if (permission[key] == true) {
      role.permissions.push(key);
    }
  });

  const completeRole = (role) => {
    if (data[0].role_id && data[0].role_id > 0) {
      role.role_id = data[0].role_id;
    }

    dispatch(updateDataRole(role));
  };

  const permissions = translatePermission(role.permissions);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Box>
        <Typography variant="h4">
          {intl.formatMessage({
            id: 'app.roles.editRole.stepper.confirmation.title',
          })}
        </Typography>

        <Typography variant="body1">
          {' '}
          {intl.formatMessage({
            id: 'app.roles.editRole.stepper.confirmation.roleName',
          })}{' '}
          {role.role_name}{' '}
        </Typography>
        <Typography variant="body1">
          {' '}
          {intl.formatMessage({
            id: 'app.roles.editRole.stepper.confirmation.permission',
          })}{' '}
        </Typography>

        <List>
          {permissions.map((el) => (
            <ListItem key={el}>
              <ListItemText> {el} </ListItemText>
            </ListItem>
          ))}
        </List>
        <Button
          color="secondary"
          onClick={() => completeRole(role)}
          size="large"
          variant="contained"
          fullWidth={true}
          sx={{ mt: 3, mb: 2 }}
        >
          {intl.formatMessage({
            id: 'app.roles.editRole.stepper.confirmation.confirmBtn',
          })}
        </Button>
      </Box>
    </Box>
  );
}

export default NameRoleForm;
